module.exports = __webpack_public_path__ + "img/gb-sct.c5df672a.svg";